import { patientsPDFFolder } from '~/config';
export const getPatientPDFUrl = (fileName) => {
    return `/api${patientsPDFFolder}${fileName}`;
};
